import _get from 'lodash/get'
import { computed, ref, useContext } from '@nuxtjs/composition-api'

export default function useSidebar() {
  const { store, $axios } = useContext()
  const sidebar = ref([])
  const isLoadingSidebar = ref(true)
  const sidebarWidgets = computed(() => {
    return _get(sidebar.value, 'template', [])
  })
  const hasSidebar = computed(() => {
    return sidebarWidgets.value.length
  })
  const school = store.state.settings.school

  async function fetchSidebar() {
    isLoadingSidebar.value = true
    const payload = await $axios.$get(`/${school}/general/publicCatalogSidebar`)
    sidebar.value = _get(payload, ['publicCatalogSidebar'], {})
    isLoadingSidebar.value = false
  }

  return {
    isLoadingSidebar,
    hasSidebar,
    sidebar,
    sidebarWidgets,
    fetchSidebar,
  }
}
